export default (sitemap: SitemapBuilder) =>
{
    sitemap.before('[[[Repozytorium plików]]]', [
        {
            name: '[[[AI CMS]]]',
            short: '[[[AI CMS]]]',
            icon: 'fal fa-fw fa-microchip-ai',
            namespace: 'Ideo.Core.Edito.Application.Permissions.AiCms',
            visible: false,
            children: [
                {
                    name: '[[[Generator metadanych SEO]]]',
                    icon: 'far fa-fw fa-search',
                    route: 'aicms-seo-metadata-generator',
                    auth: { all: ['SeoMetadataPermissions@Access'], any: [] },
                    visible: false
                }
            ]
        }
    ]);
};
